// The path name variable was {collection.name}; certificates and templates
// saved before the rename still have it. Both are filled in when a
// certificate is issued, so the editor shows and saves the new name.
const OLD_VARIABLE = /\{collection\.name\}/g
const NEW_VARIABLE = '{path.name}'

/** `value` (HTML or editor blocks) with {collection.name} as {path.name}. */
export const withPathVariable = value => {
  if (!value) return value
  if (typeof value === 'string') return value.replace(OLD_VARIABLE, NEW_VARIABLE)
  const json = JSON.stringify(value)
  return json.includes('{collection.name}')
    ? JSON.parse(json.replace(OLD_VARIABLE, NEW_VARIABLE))
    : value
}
